import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// Libs
import moment from 'moment-timezone';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';

// Components
import Tabs from '../Tabs';
import LoadingOverlay from 'react-loading-overlay';

// Actions
import {
    getNotifications,
    markNotificationAsRead,
    markAllNotificationsAsRead,
    clearAllReadNotifications,
    getNotificationCount,
} from '../../state/services/zendeskService';

import {
    NotificationsNewTab,
    NotificationsReadTab,
} from './Notifications';


class NotificationSlider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 'new',
        };

        moment.tz.setDefault('Australia/Sydney');
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleNotificationsSlider: PropTypes.func.isRequired,

        getNotifications: PropTypes.func.isRequired,
        markNotificationAsRead: PropTypes.func.isRequired,
        markAllNotificationsAsRead: PropTypes.func.isRequired,
        clearAllReadNotifications: PropTypes.func.isRequired,
        onNotificationClick: PropTypes.func.isRequired,
        getNotificationCount: PropTypes.func.isRequired,

        notifications: PropTypes.array,
        isLoadingNotifications: PropTypes.bool,

        clientname: PropTypes.string,
        useremail: PropTypes.string,
    };

    componentDidUpdate(prevProps) {
        if (
            this.props.isOpen &&
            !prevProps.isOpen
        ) {
            this.loadNotifications();
        }
    }

    loadNotifications = () => {
        this.setState({
            activeTab: 'new',
        });

        this.props.getNotifications();
    };

    handleSliderClose = () => {
        this.props.toggleNotificationsSlider();
    };

    handleNotificationClick = async (notification) => {
        const {
            markNotificationAsRead,
            getNotificationCount,
            onNotificationClick,
        } = this.props;

        if (
            notification
            && notification.id
            && !notification.is_read
        ) {
            try {
                await markNotificationAsRead(notification.id);
                await getNotificationCount();
            } catch (error) {
                console.error(
                    '[NOTIFICATION] Failed to mark notification as read:',
                    error
                );
            }
        }

        if (onNotificationClick) {
            onNotificationClick(notification);
        }
    };

    handleMarkAllNotificationsAsRead = async () => {
        const {
            markAllNotificationsAsRead,
            getNotificationCount,
        } = this.props;

        try {
            await markAllNotificationsAsRead();
            await getNotificationCount();
        } catch (error) {
            console.error(
                '[NOTIFICATION] Failed to mark all notifications as read:',
                error
            );
        }
    };

    handleClearAllNotifications = () => {
        this.props.clearAllReadNotifications()
            .then(() => {
                this.props.getNotificationCount();
            });
    };

    handleMarkNotificationAsRead = async (notificationId) => {
        const {
            markNotificationAsRead,
            getNotificationCount,
        } = this.props;

        try {
            await markNotificationAsRead(notificationId);
            await getNotificationCount();
        } catch (error) {
            console.error(
                '[NOTIFICATION] Failed to mark notification as read:',
                error
            );
        }
    };

    render() {
        const {
            isOpen,
            notifications = [],
            isLoadingNotifications,
        } = this.props;

        const newNotifications = notifications.filter(
            notification => !notification.is_read
        );

        const readNotifications = notifications.filter(
            notification => notification.is_read
        );

        return (
            <SlidingPane
                className='notification-slider'
                overlayClassName='notification-slider-overlay'
                isOpen={isOpen}
                title='Notifications'
                subtitle='Updates for bookings you follow'
                onRequestClose={this.handleSliderClose}
            >
                <div className='content'>
                    <LoadingOverlay
                        active={isLoadingNotifications}
                        spinner
                        text='Loading notifications...'
                    >
                        {!isLoadingNotifications && (
                            <Tabs
                                tabs={[
                                    {
                                        id: 'new',
                                        label: 'New',
                                        content: (
                                            <NotificationsNewTab
                                                notifications={
                                                    newNotifications
                                                }
                                                markNotificationAsRead={
                                                    this.handleMarkNotificationAsRead
                                                }
                                                markAllNotificationsAsRead={
                                                    this.handleMarkAllNotificationsAsRead
                                                }
                                                onNotificationClick={
                                                    this.handleNotificationClick
                                                }
                                            />
                                        ),
                                    },
                                    {
                                        id: 'read',
                                        label: 'Read',
                                        content: (
                                            <NotificationsReadTab
                                                notifications={
                                                    readNotifications
                                                }
                                                onClearAll={
                                                    this.handleClearAllNotifications
                                                }
                                                onNotificationClick={
                                                    this.handleNotificationClick
                                                }
                                            />
                                        ),
                                    },
                                ]}
                                defaultTab='new'
                            />
                        )}
                    </LoadingOverlay>
                </div>
            </SlidingPane>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        notifications: state.zendesk.notifications,
        isLoadingNotifications:
            state.zendesk.isLoadingNotifications,
        clientname: state.auth.clientname,
        useremail: state.auth.useremail,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getNotifications: () =>
            dispatch(getNotifications()),

        getNotificationCount: () =>
            dispatch(getNotificationCount()),

        markNotificationAsRead: (notificationId) =>
            dispatch(
                markNotificationAsRead(notificationId)
            ),

        markAllNotificationsAsRead: () =>
            dispatch(
                markAllNotificationsAsRead()
            ),

        clearAllReadNotifications: () =>
            dispatch(
                clearAllReadNotifications()
            ),
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(NotificationSlider)
);



// WEBPACK FOOTER //
// ./src/components/Sliders/NotificationSlider.js